<template>
  <div class="checkbox-property-with-text">
    <memlist-checkbox 
      :name="group.group_id"
      v-model="selected"
      @input="on_checkbox_select(prop.prop_id, $event)"
      :title="prop.name"
    />

    <div v-if="selected && prop.is_free_text">
      <memlist-text-input
        v-model="free_text"
        @change="free_text_changed"
        :state="validate_text"
      />
    </div>
  </div>
</template>

<script>
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'PropertyPageGroupCheckboxPropertyWithText',
  mixins: [ toasts ],
  props: ['group', 'prop'],
  emits: ['change'],
  data() {
    return {
      selected: null,
      free_text: null
    };
  },
  mounted() {

  },

  watch: {
    
  },

  methods: {
    on_checkbox_select(key, tof) {
      this.selected = tof;
      this.emit_change();
    },
    validate_text() {
      if (!this.free_text) {
        return null;
      }

      if (this.free_text.length > 31) {
        return false;
      }

      return null;
    },
    free_text_changed() {
      this.emit_change();
    },

    emit_change() {

      this.$emit('change', this.prop.prop_id, this.selected, this.free_text ? this.free_text.substring(0, 31) : null);

    }
  }
};
</script>
